import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';

export class CustomValidators {

    public static formatDatePicker(absCtrl: AbstractControl) {
        if (moment.isMoment(absCtrl.value)) {
            const ctrl = absCtrl.value.creationData().input;
            if (typeof ctrl === 'string' && 
                (RegularExpression.FormatoFecha).test(ctrl) ||
                typeof ctrl === 'object' && 
                ctrl.hasOwnProperty('year') && 
                ctrl.hasOwnProperty('month') && 
                ctrl.hasOwnProperty('date')
                ) {
                return null;
            }
        }

        if (!absCtrl.value && absCtrl.errors && absCtrl.errors.matDatepickerParse) {
            const dpValue = absCtrl.errors.matDatepickerParse.text;
            if (!dpValue)
                return null;
        }

        return { formatDatePicker: true };
    }

    public static pattern(reg: RegExp): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            var value = control.value ? <string>control.value : '';
            return value.match(reg) ? null : { 'pattern': { value } };
        }
    }

    public static minYears(years : number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            var minDate = moment().subtract(years, 'years');
            var value = <string>control.value;
            var momentdate = moment(value).isBefore(minDate);
            return momentdate ? { 'minYears': momentdate } : null;
        }
    }

    public static maxYears(years : number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            var maxDate ;
            if (years < 0)
                 maxDate = moment().subtract(Math.abs(years), 'years');
            else
                maxDate = moment().add(years, 'years');

            var value = <string>control.value;
            var momentdate = moment(value).isAfter(maxDate);
            return momentdate ? { 'maxYears': momentdate } : null;
        }
    }
}

export class RegularExpression {
    public static readonly NoRequiredBoxes_Letters: RegExp = /^((^$)|([A-Za-zÑñáéíóúÁÉÍÓÚ ]+))$/;
    public static readonly SOLO_LETRA: RegExp = /^([A-Za-z]+)$/;
    public static readonly LETRAS_TILDE_ENIE: RegExp = /^([A-Za-zÑñáéíóúÁÉÍÓÚ ]+)$/;
    public static readonly LETRAS_TILDE_ENIE_PUNTO: RegExp = /^()([A-Za-zÑñáéíóúÁÉÍÓÚ.]+)$/;
    public static readonly NUMERO_ESPACIO: RegExp = /^[0-9]*$/;        // Solo cadena vacia o numeros
    public static readonly SOLO_NUMERO: RegExp = /^[0-9]+$/;           // Solo numeros. No se admite cadena vacia
    public static readonly LETRAS_TILDE_ENIE_NUMERO: RegExp = /^([A-Za-z0-9ÑñáéíóúÁÉÍÓÚ ]*)$/;
    public static readonly FormatoFecha: RegExp = /^\d{2}\/\d{2}\/\d{4}$/;           // Solo numeros. No se admite cadena vacia
    public static readonly FormatEmail: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
}

export class RegularExpressionMessage {
    public static readonly SOLO_LETRA_MSG: string = 'Solo se permite letras.';
    public static readonly LETRAS_TILDE_ENIE_MSG: string = 'Solo se permite letras y ñ.';
    public static readonly LETRAS_TILDE_ENIE_PUNTO_MSG: string = 'Solo se permite letras, ñ y punto.';
    public static readonly NUMERO_ESPACIO_MSG: string = 'Solo se permite espacios y números.';
    public static readonly SOLO_NUMERO_MSG: string = 'Solo se permite números.';
    public static readonly LETRAS_TILDE_ENIE_NUMERO_MSG: string = 'Solo se permite letras, ñ y números';

}

export class MessagesValidation {
    public static readonly CAMPO_OBLIGATORIO_MSG: string = 'Campo Obligatorio';
    public static readonly SELECCIONE_OPCION_MSG: string = 'Seleccione una opción';
    public static readonly SELECCIONE_UBIGEO_MSG: string = 'Seleccione todos los campos de Ubigeo (País, Departamento, Provincia y Distrito)';
    public static readonly SELECCIONE_AFILIADO_MSG: string = 'Busque y seleccione un Afiliado';
    public static readonly SELECCIONE_PROMOTOR_MSG: string = 'Busque y seleccione un Promotor';
    public static readonly MINIMAS_CUOTAS_MSG: string = 'La cantidad mínima de cuotas es de {0}';
    public static readonly MAXIMA_CUOTAS_MSG: string = 'La cantidad máxima de cuotas es de {0}';
    public static readonly MINIMO_MONTO_MSG: string = 'El monto mínimo de cuotas es de S/{0}.00';
    public static readonly MAXIMO_MONTO_MSG: string = 'El monto máximo de cuotas es de S/{0}.00';
    public static readonly FECHA_MAXIMA_MSG: string = 'La fecha maxima es incorrecta';
    public static readonly FECHA_MINIMA_MSG: string = 'La fecha minima es incorrecta';
    public static readonly FORMATDATE_INVALID_MSG: string = 'Formato de fecha invalido';
}
